import React, { useState, useEffect } from 'react';
import { Table, Form, Button, Modal, Card } from "react-bootstrap";
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
    faEye, faPen, faPlus, faTrash, faFilter, faSync, faBox, faFolderOpen
} from '@fortawesome/free-solid-svg-icons';
import RequireRoles from '../../../components/RequireRoles';
import useFetch from "../../../hooks/useFetch";
import Swal from 'sweetalert2';
import PaginatedItems from '../../../components/administracao/Pagination';

function GerenciarLocalizacao() {
    const { params } = useParams();
    const { get, del } = useFetch();

    const defaultState = {
        localizacoes: [],
        count: 0,
        page: 1,
        filtroAtivo: false,
        filtros: {
            ordem: "AlfabeticaSala",
            sala: "",
            estante: "",
            prateleira: "",
            caixa: "", // Novo filtro
        },
        mostrarModal: false,
        registroAExcluir: { sala: "" },
        loading: true
    }

    const [state, setState] = useState(defaultState);

    useEffect(() => {
        async function initialize() {
            let [localizacoes, count] = await buscarLocalizacoes({});
            setState(prev => ({ ...prev, localizacoes, count, loading: false }));
        }
        initialize();
    }, [params]);

    async function buscarLocalizacoes(filtros) {
        if (!state.loading) setState(prev => ({ ...prev, loading: true }));
        let query = "?";
        for (const key in filtros) {
            if (filtros[key] !== "") query += `${key}=${filtros[key]}&`;
        }
        if (!filtros.ordem) query += `ordem=${state.filtros.ordem}`;

        try {
            let response = await get('/localizacao' + query);
            if (response.ok) return [response.result.data, response.result.count];
        } catch (error) { console.error(error); }
        return [[], 0];
    }

    async function handlePageChange(pageNumber) {
        window.scrollTo(0, 0);
        let [localizacoes, count] = await buscarLocalizacoes({ ...state.filtros, page: pageNumber });
        setState(prev => ({ ...prev, page: pageNumber, localizacoes, count, loading: false }));
    }

    function handleChangeFiltros(e) {
        const { name, value } = e.target;
        setState(prev => ({ ...prev, filtros: { ...prev.filtros, [name]: value } }));
    }

    // Aceita um filtro explícito opcional. Sem isso, quem chamava logo depois
    // de um setState (ex.: trocar a ordenação) acabava lendo o `state.filtros`
    // ainda com o valor antigo, porque o setState não atualiza state.filtros
    // sincronamente — a busca saía com a ordenação anterior à selecionada.
    async function filtrarLocalizacoes(filtros = state.filtros) {
        let [localizacoes, count] = await buscarLocalizacoes(filtros);
        setState(prev => ({ ...prev, localizacoes, count, filtroAtivo: true, loading: false }));
    }

    async function limparFiltros() {
        let [localizacoes, count] = await buscarLocalizacoes({});
        setState({ ...defaultState, localizacoes, count, loading: false });
    }

    async function excluirLocalizacao() {
        let response = await del('/localizacao/' + state.registroAExcluir.id_localizacao);
        if (response.ok) {
            limparFiltros();
            setState(prev => ({ ...prev, mostrarModal: false }));
        } else if (response.status === 300) {
            Swal.fire({ title: "Erro", text: "Localização em uso por um item.", icon: "error" });
        }
    }

    return (
        <div className="admin-page-container">
            <div className="admin-header-container">
                <div className="title-group">
                    <h2 className="admin-title">Gerenciamento de Localizações</h2>
                    <p className="admin-subtitle">Organize salas, estantes, caixas e envelopes do acervo</p>
                </div>
                <Link to="/admin/localizacoes/criar" className="btn-add-new" state={{ acao: "Criar" }}>
                    <FontAwesomeIcon icon={faPlus} className="me-2" /> Nova Localização
                </Link>
            </div>

            <Card className="filter-card-admin mb-4">
                <Card.Body className="p-4">
                    {/* onSubmit faz o Enter em qualquer campo aplicar o filtro. Sem isso os
                        botões abaixo (sem type="button") ficavam como type="submit" padrão
                        do HTML, e o Enter disparava um submit nativo do form sem handler —
                        ou seja, recarregava a página em vez de filtrar. */}
                    <Form onSubmit={(e) => { e.preventDefault(); filtrarLocalizacoes(); }}>
                        <div className="row g-3 mb-3">
                            <Form.Group className="col-md-3">
                                <Form.Label className="label-admin">Sala</Form.Label>
                                <Form.Control className="input-moderno" name="sala" value={state.filtros.sala} onChange={handleChangeFiltros} />
                            </Form.Group>
                            <Form.Group className="col-md-3">
                                <Form.Label className="label-admin">Estante</Form.Label>
                                <Form.Control className="input-moderno" name="estante" value={state.filtros.estante} onChange={handleChangeFiltros} />
                            </Form.Group>
                            <Form.Group className="col-md-3">
                                <Form.Label className="label-admin">Prateleira</Form.Label>
                                <Form.Control className="input-moderno" name="prateleira" value={state.filtros.prateleira} onChange={handleChangeFiltros} />
                            </Form.Group>
                            <Form.Group className="col-md-3">
                                <Form.Label className="label-admin">Caixa / Pasta</Form.Label>
                                <Form.Control className="input-moderno" name="caixa" value={state.filtros.caixa} onChange={handleChangeFiltros} />
                            </Form.Group>
                        </div>

                        <div className="filter-actions-row">
                            <div className="d-flex gap-2">
                                <Button type="button" className="btn-apply-filters" onClick={() => filtrarLocalizacoes()}><FontAwesomeIcon icon={faFilter} className="me-2" /> Filtrar</Button>
                                <Button type="button" className="btn-clear-filters" onClick={limparFiltros}><FontAwesomeIcon icon={faSync} /></Button>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                                <span className="text-muted small fw-bold">ORDENAR POR:</span>
                                <Form.Select
                                    className="small-select input-moderno w-auto"
                                    name="ordem"
                                    value={state.filtros.ordem}
                                    onChange={(e) => {
                                        // Monta o filtro novo já com a ordenação atualizada e passa
                                        // direto pra filtrarLocalizacoes, em vez de confiar no
                                        // state.filtros (que só reflete a troca no próximo render).
                                        const novosFiltros = { ...state.filtros, ordem: e.target.value };
                                        setState(prev => ({ ...prev, filtros: novosFiltros }));
                                        filtrarLocalizacoes(novosFiltros);
                                    }}
                                >
                                    <option value="AlfabeticaSala">Sala</option>
                                    <option value="AlfabeticaEstante">Estante</option>
                                    <option value="AlfabeticaPrateleira">Prateleira</option>
                                </Form.Select>
                            </div>
                        </div>
                    </Form>
                </Card.Body>
            </Card>

            <Card className="table-card-admin">
                <div className="table-responsive">
                    <Table className="modern-table mb-0">
                        <thead>
                            <tr>
                                <th>Sala / Estante / Prat.</th>
                                <th>Caixa</th>
                                <th>Envelope / Pasta</th>
                                <th className="text-center">Opções</th>
                            </tr>
                        </thead>
                        <tbody>
                            {state.loading ? (
                                <tr><td colSpan="4" className="text-center py-5"><div className="spinner-border text-teal"></div></td></tr>
                            ) : state.localizacoes?.length > 0 ? (
                                state.localizacoes.map((item, index) => (
                                    <tr key={index}>
                                        <td data-label="Sala / Estante / Prat.">
                                            <div className="d-flex flex-column">
                                                <span className="fw-bold">{item.sala}</span>
                                                <small className="text-muted">Estante {item.estante || '-'} | Prat. {item.prateleira || '-'}</small>
                                            </div>
                                        </td>
                                        <td data-label="Caixa"><span className="badge bg-light text-dark border"><FontAwesomeIcon icon={faBox} className="me-1 text-teal opacity-50" /> {item.caixa || '-'}</span></td>
                                        <td data-label="Envelope / Pasta"><span className="badge bg-light text-dark border"><FontAwesomeIcon icon={faFolderOpen} className="me-1 text-teal opacity-50" /> {item.envelope_pasta || '-'}</span></td>
                                        <td data-label="Opções">
                                            <div className="d-flex justify-content-center gap-2">
                                                <Link className="action-icon view" to={"/admin/localizacoes/" + item.id_localizacao} state={{ acao: "" }}><FontAwesomeIcon icon={faEye} /></Link>
                                                <Link className="action-icon edit" to={"/admin/localizacoes/" + item.id_localizacao} state={{ acao: "Editar" }}><FontAwesomeIcon icon={faPen} /></Link>
                                                <RequireRoles allowedRoles={['Desenvolvedor']}>
                                                    <button className="action-icon delete" onClick={() => setState(p => ({ ...p, mostrarModal: true, registroAExcluir: item }))}><FontAwesomeIcon icon={faTrash} /></button>
                                                </RequireRoles>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="4" className="text-center py-4">Nenhuma localização encontrada.</td></tr>
                            )}
                        </tbody>
                    </Table>
                </div>
                {state.localizacoes?.length > 0 && (
                    <div className="card-footer bg-white border-0 py-3 d-flex justify-content-center">
                        <PaginatedItems itemCount={state.count} itemsPerPage={20} handlePageChange={handlePageChange} />
                    </div>
                )}
            </Card>

            <Modal show={state.mostrarModal} onHide={() => setState(p => ({ ...p, mostrarModal: false }))} centered className="modern-modal">
                <Modal.Header closeButton className="modal-header-teal"><Modal.Title className="text-white fs-5">Excluir Localização</Modal.Title></Modal.Header>
                <Modal.Body className="p-4">Deseja excluir a localização <strong>{state.registroAExcluir.sala}</strong>?</Modal.Body>
                <Modal.Footer className="border-0 p-4 pt-0">
                    <Button variant="light" onClick={() => setState(p => ({ ...p, mostrarModal: false }))}>Cancelar</Button>
                    <Button variant="danger" onClick={excluirLocalizacao}>Confirmar Exclusão</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default GerenciarLocalizacao;